import { ArrowRight, Info, X } from "lucide-react";
import { motion } from "motion/react";
import { useTranslation } from "react-i18next";

import { Alert } from "@/components/ui/v2/alert";
import { Button } from "@/components/ui/v2/button";

type TourPromoBannerProps = {
  copyKey: string;
  onStart: () => void;
  onDismiss: () => void;
};

export function TourPromoBanner({ copyKey, onStart, onDismiss }: TourPromoBannerProps) {
  const { t } = useTranslation();
  const key = (part: string) => `${copyKey}.${part}`;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
      className="col-span-full pb-4"
    >
      <Alert variant="info" role="region" aria-label={t(key("title"))} className="flex flex-wrap items-center gap-x-3.5 gap-y-2 py-3">
        <Info aria-hidden className="size-5 shrink-0" />
        <div className="flex min-w-56 flex-1 flex-col gap-0.5">
          <p className="text-sm font-semibold">{t(key("title"))}</p>
          <p className="text-xs">{t(key("body"))}</p>
        </div>
        <div className="ml-auto flex items-center gap-1">
          <Button variant="link" size="sm" className="text-current" onClick={onStart}>
            {t(key("start"))}
            <ArrowRight aria-hidden />
          </Button>
          <Button variant="ghost" size="icon-sm" aria-label={t(key("dismiss"))} onClick={onDismiss}>
            <X aria-hidden />
          </Button>
        </div>
      </Alert>
    </motion.div>
  );
}
